import ClubDashboard from './ClubDashboard';

const ClubHome = () => {
    return <ClubDashboard />;
};
export default ClubHome;
